exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._1c81EB313W_5wan-vTCCm3{padding:1px 0 0 0}", ""]);
// Exports
exports.locals = {
	"todos": "_1c81EB313W_5wan-vTCCm3"
};